import { render, staticRenderFns } from "./Kiosks.vue?vue&type=template&id=19874bc7&"
import script from "./Kiosks.vue?vue&type=script&lang=js&"
export * from "./Kiosks.vue?vue&type=script&lang=js&"
import style0 from "./Kiosks.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports